import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CookieSettingsButton } from '@/components/consent/CookieSettingsButton';
import { isConsentManaged } from '@/lib/consent/cookieYes';
import { useCookieConsentBanner } from '@/lib/consent/useCookieConsentBanner';
import { useTranslation } from 'react-i18next';
import { Link } from 'wouter';
import { currentPath, rememberReturnPath } from './authReturn';
import { AUTH_TEXT_LINK } from './authStyles';
/**
 * Terms, Privacy and Cookie settings links shown beneath the auth card on the sign-in screens.
 * Every public sign-in surface renders this, so it is also where the cookie-consent banner loads.
 */
export function LegalLinks() {
    const { t } = useTranslation();
    useCookieConsentBanner();
    // The legal page's "Back" returns here (a /link/<code> page, not always /login).
    const rememberHere = () => rememberReturnPath('legal', currentPath());
    return (_jsxs("nav", { className: "text-muted-foreground flex items-center justify-center gap-3 text-xs pointer-coarse:gap-5", children: [_jsx(Link, { href: "/terms", className: AUTH_TEXT_LINK, onClick: rememberHere, children: t('legal.termsLink') }), _jsx("span", { "aria-hidden": "true", className: "bg-muted-foreground/30 h-3 w-px" }), _jsx(Link, { href: "/privacy", className: AUTH_TEXT_LINK, onClick: rememberHere, children: t('legal.privacyLink') }), isConsentManaged() && (_jsxs(_Fragment, { children: [_jsx("span", { "aria-hidden": "true", className: "bg-muted-foreground/30 h-3 w-px" }), _jsx(CookieSettingsButton, { className: AUTH_TEXT_LINK })] }))] }));
}
